import React, { useCallback, useRef, useState } from "react";
import GoogleMapReact from 'google-map-react';
import { lang } from "../../../../middleware/lang";

type MarkerProps = {
  lat: number,
  lng: number
}
const Marker: React.FC<MarkerProps> = () => {
  return <div className="fa fa-map-marker fa-3x" style={{ color: 'red' }}></div>
}

type Props = {
  lat: number,
  lng: number
  updateMarker: (data: any) => void
  disabled?: boolean
};

const GoogleMap: React.FC<Props> = ({ lat, lng, updateMarker, disabled }) => {
  const [center, setCenter] = useState({ lat, lng });
  const mapRef = useRef<any>(null);

  const onGoogleApiLoaded = useCallback(({ map }: { map: any }) => {
    mapRef.current = map;
  }, []);

  const updateCoords = (e: any) => {
    if (disabled) return;
    setCenter({
      lat: e.center.lat(),
      lng: e.center.lng()
    });
  }

  const update = () => {
    updateMarker(center);
  }

  if (!lat || !lng) {
    return <div></div>;
  }

  return (
    <div>
      {disabled && (
        <div className="alert alert-info py-1 mb-2">
          <i className="fas fa-lock mr-1"></i>
          {lang(
            "Completa la dirección para desbloquear el mapa",
            "Fill in the address to unlock the map"
          )}
        </div>
      )}
      <div style={{ height: '60vh', width: '100%', position: 'relative' }}>
        {/* key forces remount when parent passes new lat/lng (e.g. after geocoding) */}
        <GoogleMapReact
          key={`${lat}-${lng}`}
          bootstrapURLKeys={{ key: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "" }}
          defaultCenter={{ lat, lng }}
          defaultZoom={18}
          onDragEnd={e => updateCoords(e)}
          onGoogleApiLoaded={onGoogleApiLoaded}
          yesIWantToUseGoogleMapApiInternals
          options={{
            draggable: !disabled,
            zoomControl: !disabled,
            scrollwheel: !disabled,
            disableDoubleClickZoom: !!disabled,
            gestureHandling: disabled ? 'none' : 'auto',
          }}
        >
          <Marker
            lat={center.lat}
            lng={center.lng}
          />
        </GoogleMapReact>
        {disabled && (
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.15)',
            cursor: 'not-allowed',
            zIndex: 1,
          }} />
        )}
      </div>
      {!disabled && (
        <button className="btn btn-primary mt-2" onClick={update}>
          {lang("Guardar ubicación", "Save location")}
        </button>
      )}
    </div>
  );
}

export default GoogleMap;
